import React from "react";
import { ConfigProvider } from "antd";
import "./App.css";
import PhilosophyOracle from "./PhilosophyOracle";

// Custom Theme Configuration
const themeConfig = {
  token: {
    fontFamily: "'Lora', serif", // Base font
    colorPrimary: "#8c7b6c", // Muted Bronze (Professional & Trustworthy)
    colorLink: "#8c7b6c",
    colorBgLayout: "#fdfbf7", // Warm Paper Background
    borderRadius: 8,
    fontSize: 16,
  },
  components: {
    Button: {
      colorPrimary: "#2c3e50", // Dark Navy for primary actions
      algorithm: true, // Enable automatic shade generation
      fontWeight: 600,
      fontFamily: "'Playfair Display', serif", // Headings/Buttons get the fancy font
    },
    Card: {
      headerFontSize: 20,
      fontFamily: "'Playfair Display', serif",
    },
    Typography: {
      fontFamilyCode: "'Lora', serif",
    },
    Select: {
      controlHeight: 45, // Taller inputs for better touch/feel
    },
    Input: {
      controlHeight: 45,
    },
  },
};

function App() {
  return (
    <ConfigProvider theme={themeConfig}>
      <PhilosophyOracle />
    </ConfigProvider>
  );
}

export default App;
